import { render, staticRenderFns } from "./SuccessTicketForm.vue?vue&type=template&id=0d2296ab&"
import script from "./SuccessTicketForm.vue?vue&type=script&lang=js&"
export * from "./SuccessTicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports